var render, staticRenderFns
import script from "./CrtCompany.vue?vue&type=script&lang=js&"
export * from "./CrtCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206507c4')) {
      api.createRecord('206507c4', component.options)
    } else {
      api.reload('206507c4', component.options)
    }
    
  }
}
component.options.__file = "src/views/Company/AddInfo/CrtCompany.vue"
export default component.exports